import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import Select from './Select'
import AutoComplete from './AutoComplete'
import {
  useGetAffiliazioniLightQuery,
  useGetArbitriQuery,
} from '../hooks/api-slice'

const USER_TYPES = ['Società', 'Arbitro']

const DialogImpersonation = ({ open, handleClose, triggerFunction }) => {
  const { data: affiliazioniLight } = useGetAffiliazioniLightQuery()
  const { data: arbitri } = useGetArbitriQuery()

  const [userType, setUserType] = useState()
  const [user, setUser] = useState()

  useEffect(() => {
    if (userType) setUser()
  }, [userType])

  useEffect(() => {
    if (open) {
      setUserType(USER_TYPES[0])
    }
    if (!open) {
      setUserType()
      setUser()
    }
  }, [open])

  const getOptionLabelAff = op => {
    const a = affiliazioniLight?.find(a => a?.id === (op?.id || op))
    return `${a?.codiceSocieta} - ${a?.nomeSocieta}`
  }

  const getOptionLabelArb = op => {
    const a = arbitri?.find(a => a?.id === (op?.id || op))
    return `${a?.nome} ${a?.cognome}`
  }

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(user)}
      title='Impersonazione utente'
      textConfirm='Ok'
    >
      <Grid container spacing={2} paddingTop={1} sx={{ width: '100%' }}>
        <Grid size={12}>
          <Select
            label='Tipo di utente'
            value={userType}
            options={USER_TYPES}
            onChange={setUserType}
          />
        </Grid>
        {userType === USER_TYPES[0] && (
          <Grid size={12}>
            <AutoComplete
              id='available-societa'
              label='Società'
              value={affiliazioniLight?.find(a => a?.codiceSocieta === user)}
              options={affiliazioniLight}
              getOptionLabel={getOptionLabelAff}
              isOptionEqualToValue={(op, value) => op?.codiceSocieta === value}
              disabled={!affiliazioniLight}
              onChange={i => setUser(i?.codiceSocieta)}
            />
          </Grid>
        )}
        {userType === USER_TYPES[1] && (
          <Grid size={12}>
            <AutoComplete
              id='available-arbitri'
              label='Arbitro'
              value={arbitri?.find(a => a?.codiceFiscale === user)}
              options={arbitri}
              getOptionLabel={getOptionLabelArb}
              isOptionEqualToValue={(op, value) => op?.codiceFiscale === value}
              disabled={!arbitri}
              onChange={i => setUser(i?.codiceFiscale)}
            />
          </Grid>
        )}
      </Grid>
    </Dialog>
  )
}

export default DialogImpersonation
